import { MDSLoadingSpinner } from "@/mds/components/loading/loading-spinner";
import styled from "@emotion/styled";

export const OptimisticDataImportItem = () => (
  <ImportItemContainer>
    <MDSLoadingSpinner size={16} />
    <span>Starting import...</span>
  </ImportItemContainer>
);

const ImportItemContainer = styled.div({
  display: "flex",
  alignItems: "center",
  gap: 8,
});
